export default "__VITE_ASSET__BtGcOJlr__"